var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { StateBuildingGraphics } from "../../graphics/StateBuildingGraphics";
import { selectActiveThemedEventInfo, selectThemedEvent, selectThemedEventCanPlayerJoin, selectThemedEventIsQuestsCompleted, selectThemedEventIsRewardCollected, selectThemedEventPlayerLevelIsEnough, } from "../../selectors/selectEventInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { shallowDiffers } from "../../utils/shallowDiffers";
import { OutskirtBuilding, } from "../outskirts/OutskirtBuilding";
var OutskirtBuildingThemedEvent = /** @class */ (function (_super) {
    __extends(OutskirtBuildingThemedEvent, _super);
    function OutskirtBuildingThemedEvent() {
        var _this = _super.call(this, IdOutskirtBuildings.ThemedEvent) || this;
        _this.shouldUpdate = function (props, prevProps) {
            if (!props.areAssetsLoaded) {
                return false;
            }
            return (!prevProps ||
                shallowDiffers(props.data, prevProps.data) ||
                props.isAccessible !== prevProps.isAccessible ||
                prevProps.areAssetsLoaded !== props.areAssetsLoaded ||
                prevProps.shouldRenderCallout !== props.shouldRenderCallout);
        };
        _this.mapState = function (state) {
            var baseMapState = _this.baseMapState(state);
            var themedEventInfo = selectActiveThemedEventInfo(state);
            var isAnyEventRunning = selectThemedEvent(state) !== undefined;
            var playerLevelQualifiesUser = selectThemedEventPlayerLevelIsEnough(state);
            var shouldRenderCallout = selectThemedEventCanPlayerJoin(state) ||
                (selectThemedEventIsQuestsCompleted(state) &&
                    !selectThemedEventIsRewardCollected(state));
            return __assign({}, baseMapState, { isAnyEventRunning: isAnyEventRunning,
                playerLevelQualifiesUser: playerLevelQualifiesUser,
                shouldRenderCallout: shouldRenderCallout,
                themedEventInfo: themedEventInfo });
        };
        _this.update = function (props) {
            _this.baseUpdate(props, StateBuildingGraphics.Idle, true, props.shouldRenderCallout);
            if (props.isAccessible && props.themedEventInfo) {
                _this.loca = props.themedEventInfo.category.toString();
            }
            else if (props.playerLevelQualifiesUser && !props.isAnyEventRunning) {
                _this.loca = IdLoca.tooltip_eventHub_web;
            }
        };
        return _this;
    }
    return OutskirtBuildingThemedEvent;
}(OutskirtBuilding));
export { OutskirtBuildingThemedEvent };



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/OutskirtBuildingThemedEvent.ts
// module id = 2227
// module chunks = 3